import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Output } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { DdcButtonUOneComponent } from '../ddc-button-u-one/ddc-button-u-one.component'
import { DdcRotatingBorderCardComponent } from '../ddc-rotating-border-card/ddc-rotating-border-card.component'

@Component({
  selector: 'ddc-upgrade-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    DdcButtonUOneComponent,
    DdcRotatingBorderCardComponent,
  ],
  templateUrl: './ddc-upgrade-card.component.html',
  styleUrl: './ddc-upgrade-card.component.scss',
})
export class DdcUpgradeCardComponent {
  @Output() upgradeClicked = new EventEmitter<void>()

  onUpgradeClick(): void {
    this.upgradeClicked.emit()
  }
}
